const RAGroupApplications = ({t, applications, dateFormat}) => {
    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>{t("admin.table.th.name")}</th>
                        <th>{t("admin.table.th.company")}</th>
                        <th>{t("admin.table.th.email")}</th>
                        <th>{t("admin.table.th.phone")}</th>
                        <th>{t("admin.table.th.platform")}</th>
                        <th>{t("admin.table.th.devtype")}</th>
                        <th>{t("admin.table.th.language")}</th>
                        <th>{t("admin.table.th.date")}</th>
                    </tr>
                </thead>
                <tbody>
                    {applications && applications.map((application, key) => (
                        <tr key={key}>
                            <td className="number">{key+1}</td>
                            <td>{application.name ? application.name : `${application?.firstname} ${application?.lastname$}` }</td>
                            <td>{application?.companyName}</td>
                            <td>
                                <a href={`mailto:${application?.email}`}>
                                    {application?.email}
                                </a>
                            </td>
                            <td>
                                <a href={`tel:${application?.phone?.replace(/ /g, '')}`}>
                                    {application?.phone}
                                </a>
                            </td>
                            <td>
                                <div className="os-container">
                                    {(application.platform && application.platform.length>0) ? (
                                        application.platform && application.platform.length>0 && application.platform.map((oss, j)=> (
                                            <div key={j} className="os">{t(`admin.table.data.os.${oss}`)}</div>
                                        ))
                                    ) : (
                                        application.os && application.os.length>0 && application.os.map((oss, j)=> (
                                            <div key={j} className="os">{t(`admin.table.data.os.${oss}`)}</div>
                                        ))
                                    )}
                                </div>
                            </td>
                            <td>
                            {application.devtype ? 
                                t(`admin.table.data.devtype.${application.devtype}`)
                                : 
                                t(`admin.table.data.format.${application.format}` )
                                }
                            </td>

                            <td className="lang">{application.lang}</td>
                            <td>{dateFormat(application.createdAt)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {
                (!applications || applications.length === 0) && (
                    <div className="none">
                        {t("admin.table.applications.none")}
                    </div>
                )
            }
        </>
    )
};

export default RAGroupApplications;